import { UserCapacity } from '@wui/common-library'

export const getIsEnoughCapacity = (capacity?: UserCapacity) => {
  if (!capacity?.totalCapacity) return true

  return capacity.totalCapacity > 1
}
